import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=419c9ccc&scoped=true&"
import script from "./Loader.js?vue&type=script&lang=js&"
export * from "./Loader.js?vue&type=script&lang=js&"
import style0 from "./Loader.scss?vue&type=style&index=0&id=419c9ccc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419c9ccc",
  null
  
)

export default component.exports